import { ProjectPartPopupCtrl } from './project.part.popup.controller';
import template from './project.part.popup.html';

export const partPopup: angular.IDirectiveFactory = () => ({
  bindToController: true,
  restrict: 'AE',
  controller: ProjectPartPopupCtrl,
  controllerAs: 'vm',
  template,
  scope: {
    isActive: '=',
    projectPartData: '=',
  },
});
